import { ChevronDownIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react"

type PageSelectorProps = {
  pageSize: number
  setPageNumber: (n: number) => void
  setPageSize: (n: number) => void
}
const PageSelector = ({
  pageSize,
  setPageSize,
  setPageNumber,
}: PageSelectorProps) => {
  return (
    <Box display='flex' alignItems='center' w='120px' mr='20px'>
      {/*<Text*/}
      {/*  size={{ base: "xs", md: "sm" }}*/}
      {/*  variant='black'*/}
      {/*  marginBottom={0}*/}
      {/*  fontWeight='500'*/}
      {/*  mr='10px'*/}
      {/*>*/}
      {/*  Rows*/}
      {/*</Text>*/}
      <Menu variant={"dropDown"} isLazy lazyBehavior='unmount'>
        <MenuButton
          as={Button}
          variant={"dropDownButton"}
          w='full'
          pl={2}
          pr={0}
        >
          <Box
            alignItems='center'
            display='flex'
            justifyContent='space-between'
            gap='1'
          >
            <Text
              size={{ base: "xs", md: "sm" }}
              variant='black'
              marginBottom={0}
              fontWeight='500'
              overflow='clip'
              whiteSpace='nowrap'
              wordBreak='keep-all'
              textOverflow='ellipsis'
            >
              {pageSize} Rows
            </Text>
            <ChevronDownIcon color='currentcolor' w={"8"} h={"6"} />
          </Box>
        </MenuButton>
        <MenuList w='70px' minW='auto'>
          {[10, 15, 20, 30].map((option) => (
            <MenuItem
              as={Button}
              key={option}
              variant={"solid"}
              isActive={option === pageSize}
              justifyContent={"flex-start"}
              value={option}
              onClick={() => {
                setPageSize(option)
                setPageNumber(0)
              }}
            >
              {option}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  )
}
export default PageSelector
